function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { CustomFormBuilder } from './Helpers/CustomFormBuilder';
import { DropdownBuilder } from './Helpers/DropdownBuilder';
import { ErrorBuilder } from './Helpers/ErrorBuilder';
import { FormManager } from './Helpers/FormManager';
import { NumberUtils } from './Helpers/NumberUtils';
import { TextFormatter } from './Helpers/TextFormatter';
import { HouseholdApiService } from './Services/HouseholdApiService';
import { LookupApiService } from './Services/LookupApiService';
import { MissionTripApiService } from './Services/MissionTripApiService';
import { UserService } from './Services/UserService';
import { AddressAutoComplete } from './Shared/AddressAutoComplete';
/* jshint esversion: 8 */

import { ComponentBase } from './Shared/ComponentBase';
import { Configuration } from './Shared/Configuration';
import { I18N } from './Shared/I18n';
export var MppMissionTrip = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppMissionTrip, _ComponentBase);

  var _super = _createSuper(MppMissionTrip);

  function MppMissionTrip() {
    var _this;

    _classCallCheck(this, MppMissionTrip);

    _this = _super.call(this);
    var config = new Configuration();
    _this._appRoot = config.GetAppRoot();
    _this._getLocalCountryCode = config.GetLocalCountryCode;
    _this._addressAutoComplete = new AddressAutoComplete(_this._root);
    _this.userLoggedIn = false;
    return _this;
  }

  _createClass(MppMissionTrip, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));

      if (!!this._$missionTripWrapper) {
        this.loadAttributes();
        this.LoadMissionTrip(this.i18n);
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.pledgeCampaignID = this.getAttribute("pledgecampaignid") || "0";
      this.applicantEmailTemplate = this.getAttribute("applicantemailtemplate") || "0";
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N(MppMissionTrip.WidgetDetails.tag)["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this2._root.innerHTML = "Unable to connect. Please check Permitted URLs.";
                  } else {
                    _this2._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context.sent;
                this.i18n = i18n;
                this.userInfo = null; // Load attributes

                this.loadAttributes();

                if (!this.pledgeCampaignID || this.pledgeCampaignID === "0") {
                  this._currentUrl = new URL(window.location.href);
                  this.pledgeCampaignID = this._currentUrl.searchParams.get("pledgecampaignid") || "0";
                }

                this._root.innerHTML = "\n\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\t\t\t<div class=\"mppw-component-container mpp-mission-trip\">\n\t\t\t\t<div id=\"emptyContainer\"></div>\n\t\t\t\t<div id=\"missionTripWrapper\"></div>\n\t\t\t</div>\n\t\t");
                this._locale = localStorage.userLocale || "en"; // Selectors

                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$missionTripWrapper = this._root.querySelector("#missionTripWrapper");
                this._$successContainer = this._root.querySelector("#successContainer"); // Templates

                this._$emptyContainer.innerHTML +=  `<i class="mppw-spinner"></i>` ;
                this._$missionTripWrapper.innerHTML =  `<div id="missionTripDetails"></div><form id="pledgeForm"><h2>${i18n.applyTitle}</h2><input type="hidden" name="PledgeCampaignId" value="${this.pledgeCampaignID}"/> <input type="hidden" name="ApplicantEmailTemplateId" value="${this.applicantEmailTemplate}"/> <input type="hidden" name="ContactId" id="ContactID" value="0"/> <input type="hidden" id="TotalPledge" name="TotalPledge" value="0"/><div id="applyAsWrapper"><h3>${i18n.personalDetailsTitle}</h3><div class="form--row"><div class="form--col"><div class="mppw-form-field mppw-form-field__static-container"><select class="mppw-form-field__control" id="applyAs" value="0"><option value="0">${i18n.blankFormLabel}</option></select> <label class="mppw-form-field__label">${i18n.applyAsLabel}...</label></div></div></div></div><div id="alertContainer"></div><div id="contactFormWrapper"><h3>${i18n.contactTitle}</h3><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input type="text" id="FirstName" name="FirstName" class="mppw-form-field__control" required="" data-required-message="First Name is required please"/> <label class="mppw-form-field__label" for="FirstName">${i18n.firstNameLabel}*</label></div></div><div class="form--col"><div class="mppw-form-field"><input type="text" id="LastName" name="LastName" class="mppw-form-field__control" required="" data-required-message="Last Name is required please"/> <label class="mppw-form-field__label" for="LastName">${i18n.lastNameLabel}*</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input type="email" id="Email" name="EmailAddress" class="mppw-form-field__control" required="" data-required-message="Email is required please"> <label class="mppw-form-field__label" for="Email">${i18n.emailLabel}*</label></div></div><div class="form--col"><div class="mppw-form-field"><input type="tel" id="MobilePhoneNumber" name="MobilePhoneNumber" class="mppw-form-field__control" maxlength="50"> <label class="mppw-form-field__label" for="MobilePhoneNumber">${i18n.mobilePhoneLabel}</label></div></div></div></div><div id="addressFormWrapper"><h3>${i18n.addressTitle}</h3><input type="hidden" name="AddressId"/><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="AddressLine1" name="AddressLine1" class="mppw-form-field__control" autocomplete="off"> <label class="mppw-form-field__label" for="AddressLine1">${i18n.addressLineLabel} 1:</label></div><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="AddressLine2" name="AddressLine2" class="mppw-form-field__control" autocomplete="off"> <label class="mppw-form-field__label" for="AddressLine2">${i18n.addressLineLabel} 2:</label></div><div class="form--row"><div class="form--col"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="City" name="City" class="mppw-form-field__control"> <label class="mppw-form-field__label" for="City">${i18n.cityLabel}:</label></div></div><div class="form--col"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="StateRegion" name="StateRegion" class="mppw-form-field__control"> <label class="mppw-form-field__label" for="StateRegion">${i18n.stateLabel}:</label></div></div><div class="form--col"><div class="mppw-form-field mppw-form-field__static-container"><input type="text" id="PostalCode" name="PostalCode" class="mppw-form-field__control"> <label class="mppw-form-field__label" for="PostalCode">${i18n.postalCodeLabel}:</label></div></div></div><div class="mppw-form-field mppw-form-field__static-container"><select id="Country" name="Country" class="mppw-form-field__control" value=""></select> <label class="mppw-form-field__label" for="Country">${i18n.countryLabel}:</label></div></div><div id="formFields"></div><div class="mppw-right form--footer form--row"><div class="form--col"></div><div class="form--col"><input type="submit" class="mppw-btn primary submit--btn" id="createPledge" value="${i18n.applyButtonLabel}"/></div></div></form>` ; // Selectors from Template (Form)

                this._$alertContainer = this._root.querySelector("#alertContainer");
                this._$loginButton = this._root.querySelector('#loginButton');
                this._$createPledge = this._root.querySelector("#createPledge");
                this._$pledgeForm = this._root.querySelector('#pledgeForm');
                this._$applyAsWrapper = this._root.querySelector('#applyAsWrapper');
                this._$applyAs = this._root.querySelector('#applyAs');
                this._$contactFormWrapper = this._root.querySelector('#contactFormWrapper');
                this._$addressFormWrapper = this._root.querySelector('#addressFormWrapper');
                this._$totalPledge = this._root.querySelector('#TotalPledge');
                this._$firstName = this._root.querySelector('#FirstName');
                this._$lastName = this._root.querySelector('#LastName');
                this._$email = this._root.querySelector('#Email');
                this._$contactId = this._root.querySelector('#ContactID');
                this._$addressLine1 = this._root.querySelector('#AddressLine1');
                this._$addressLine2 = this._root.querySelector('#AddressLine2');
                this._$city = this._root.querySelector('#City');
                this._$stateRegion = this._root.querySelector('#StateRegion');
                this._$postalCode = this._root.querySelector('#PostalCode');
                this._$country = this._root.querySelector('#Country');
                this._$formFields = this._root.querySelector("#formFields");
                this._customFormGuid = null;
                this._customFormId = null; // Selectors (Mission Trip Details)

                this._$missionTripDetails = this._root.querySelector('#missionTripDetails'); // Services

                this._missionTripService = new MissionTripApiService();
                this._lookupService = new LookupApiService(); // Initially hide form

                this._$pledgeForm.style.display = "none"; // Login Listener verify with Contact Info

                _context.next = 42;
                return this.VerifyLogin(this.i18n);

              case 42:
                // Load Mission Trip
                this.LoadMissionTrip(this.i18n); // Wire-up event listeners:

                this.BindEventListeners(this.i18n);

              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "LoadMissionTrip",
    value: function LoadMissionTrip(i18n) {
      var _this3 = this;

      var renderSuccessMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // Clear any existing alerts
      ErrorBuilder.ClearAllAlerts(this._$alertContainer);

      this._missionTripService.GetMissionTrip(this.pledgeCampaignID).then(function (missionTripResponse) {
        // Show form
        _this3._$pledgeForm.style.display = "";
        var photo = missionTripResponse.photo,
            title = missionTripResponse.title,
            description = missionTripResponse.description,
            campaignGoal = missionTripResponse.campaignGoal,
            pledged = missionTripResponse.pledged,
            received = missionTripResponse.received,
            campaignStartDate = missionTripResponse.campaignStartDate,
            campaignEndDate = missionTripResponse.campaignEndDate,
            fundraisingGoal = missionTripResponse.fundraisingGoal,
            allowOnlinePledge = missionTripResponse.allowOnlinePledge,
            pledgeBeyondEndDate = missionTripResponse.pledgeBeyondEndDate,
            userHasAlreadyPledged = missionTripResponse.userHasAlreadyPledged,
            maximumRegistrants = missionTripResponse.maximumRegistrants,
            numberOfPledges = missionTripResponse.numberOfPledges,
            customFormGuid = missionTripResponse.customFormGuid,
            customFormId = missionTripResponse.customFormId,
            forceLogin = missionTripResponse.forceLogin,
            campaignEventStartDate = missionTripResponse.campaignEventStartDate,
            campaignEventEndDate = missionTripResponse.campaignEventEndDate,
            eventId = missionTripResponse.eventId; // variables used in mpp-mission-trip-pledge.html

        var PLEDGE_CAMPAIGN_PHOTO = photo && photo;
        var PLEDGE_CAMPAIGN_TITLE = title && title || 'No campaign title found';
        var PLEDGE_CAMPAIGN_DESCRIPTION = description && new TextFormatter(description).addLineBreaks() || 'No campaign description found';
        var PLEDGE_CAMPAIGN_START_DATE = eventId ? _this3.ConvertDate(campaignEventStartDate) : null;
        var PLEDGE_CAMPAIGN_END_DATE = eventId ? _this3.ConvertDate(campaignEventEndDate) : null;
        var PLEDGE_CAMPAIGN_TRIP_DATES = eventId ? "".concat(PLEDGE_CAMPAIGN_START_DATE, " - ").concat(PLEDGE_CAMPAIGN_END_DATE) : '';
        var PLEDGE_CAMPAIGN_PLEDGED = NumberUtils.toCurrencyString(pledged);
        var PLEDGE_CAMPAIGN_GOAL = NumberUtils.toCurrencyString(campaignGoal);
        var PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE = pledged / campaignGoal * 100;
        var PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE = received / campaignGoal * 100;
        var PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE_VALUE = Number(PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE).toLocaleString();
        var PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE_VALUE = Number(PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE).toLocaleString();
        _this3._customFormGuid = customFormGuid;
        _this3._customFormId = customFormId;

        if (pledgeBeyondEndDate) {
          PLEDGE_CAMPAIGN_END_DATE = ""; // remove max for date
        }

        _this3._$missionTripDetails.innerHTML =  `<div class="mpp-innerpage"><div class="mpp-card--header"><img id="photo" class="${PLEDGE_CAMPAIGN_PHOTO == null ? 'hidden' : 'mpp-mission-trip--photo'}" src="${PLEDGE_CAMPAIGN_PHOTO}"/></div><h1 id="title">${PLEDGE_CAMPAIGN_TITLE}</h1><p id="description">${PLEDGE_CAMPAIGN_DESCRIPTION}<br/><strong id="tripDatesLabel">${i18n.tripDatesLabel}&nbsp;</strong> <span id="tripDates">${PLEDGE_CAMPAIGN_TRIP_DATES}</span><br/><strong>${i18n.fundraisingGoalLabel}:&nbsp;</strong> <span id="FundraisingGoalValue">0</span></p><h2>${i18n.progressTitle}</h2><div class="progress--container"><h4 class="progress--subtitle">${PLEDGE_CAMPAIGN_PLEDGED} ${i18n.pledgedOfLabel} ${PLEDGE_CAMPAIGN_GOAL} ${i18n.goalLabel}</h4><svg width="100%" height="19"><defs><linearGradient id="gradient"><stop offset="0%" stop-color="#1b88b0"></stop><stop offset="100%" stop-color="#1fb5ac"></stop></linearGradient></defs><g><rect class="background" y="2" height="15" rx="4" ry="4" fill="#efefef" width="100%"></rect><rect class="pledged" y="2" height="15" rx="4" ry="4" fill="url(#gradient)" width="${PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE > 100 ? 100 : PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE}%"></rect><rect class="received" x="${PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE > 100 ? 100 : PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE}%" fill="#000" width="2" height="19"></rect></g></svg><div class="mpp-innerpage"><p class="mpp-card--description"><span class="progress-legend progress-legend--received"></span>${PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE_VALUE}% ${i18n.receivedLabel} <span class="progress-legend progress-legend--pledged"></span>${PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE_VALUE}% ${i18n.pledgedLabel}</p></div></div></div>` ;
        _this3._$tripDatesLabel = _this3._root.querySelector('#tripDatesLabel');
        _this3._$tripDates = _this3._root.querySelector('#tripDates');

        if (!eventId) {
          _this3._$tripDatesLabel.style.display = 'none';
          _this3._$tripDates.style.display = 'none';
        } // assign fundraisingGoal to TotalPledge


        _this3._$totalPledge.value = fundraisingGoal || 0;
        _this3._root.querySelector('#FundraisingGoalValue').innerText = NumberUtils.toCurrencyString(fundraisingGoal); // Hide pledge form if maximum registrants value is met, do not hide if value is -1 or null

        var hideFormBasedOnRegistrants = false;

        if (maximumRegistrants === -1 || maximumRegistrants === null) {
          hideFormBasedOnRegistrants = false;

          if (renderSuccessMessage === true) {
            ErrorBuilder.RenderAlert(_this3._$alertContainer, 'success', i18n.pledgeFormSuccessMessage);
          }
        } else {
          hideFormBasedOnRegistrants = numberOfPledges >= maximumRegistrants ? true : false; // Display success message - See WID-566
          // This is really only ever used when the last person or max registrant submits the form
          // this will show both the success message as well as the max registrants message

          if (hideFormBasedOnRegistrants === true) {
            if (renderSuccessMessage === true) {
              ErrorBuilder.RenderAlert(_this3._$alertContainer, 'success', i18n.pledgeFormSuccessMessage);
            }
          } else {
            if (renderSuccessMessage === true) {
              ErrorBuilder.RenderAlert(_this3._$alertContainer, 'success', i18n.pledgeFormSuccessMessage);
            }
          }
        } // hide pledge form if now allowed online or campaign end is not null and less than todays date


        var hideFormBasedOnEndDate = campaignEndDate !== null && new Date().getTime() > new Date(campaignEndDate).getTime();

        if (allowOnlinePledge === false || hideFormBasedOnEndDate || hideFormBasedOnRegistrants) {
          _this3._$pledgeForm.style.display = "none";
          ErrorBuilder.RenderAlert(_this3._$alertContainer, 'warning', i18n.notAcceptingPledgesMessage);
        } else {
          // Display custom form if any
          _this3.DrawCustomForm();
        }

        if (forceLogin !== null && forceLogin === true && _this3.userLoggedIn === false) {
          _this3.HideContactBlankForm();

          _this3._$addressFormWrapper.style.display = "none";
          _this3._$createPledge.style.display = "none";
        } else {
          if (!!_this3.userLoggedIn && !!_this3.userInfo.extentedProperties && !!_this3.userInfo.extentedProperties.ext_Address_Line_1) {
            _this3.HideAddressBlankForm();
          } else {
            _this3.ShowAddressBlankForm();
          }

          _this3._$createPledge.style.display = "";
        } // display warning if user has already pledged


        if (userHasAlreadyPledged) {
          ErrorBuilder.RenderAlert(_this3._$alertContainer, 'warning', i18n.userHasAlreadyPledgedMessage);
        }

        _this3._$emptyContainer.innerHTML = "";
      })["catch"](function (error) {
        // Log/display error
        console.error('[mpp-mission-trip.js]: LoadMissionTrip Error: ', error);
        _this3._$missionTripWrapper.style.display = 'none';
        _this3._$emptyContainer.innerHTML = "";
        ErrorBuilder.RenderAlert(_this3._$emptyContainer, 'warning', i18n.noMissionTripFound);
      });
    }
  }, {
    key: "ConvertDate",
    value: function ConvertDate(dateStr) {
      var date = dateStr.slice(0, 10).split('-');
      return "".concat(date[1], "/").concat(date[2], "/").concat(date[0]);
    }
  }, {
    key: "VerifyLogin",
    value: function VerifyLogin(i18n) {
      var _this4 = this;

      return UserService.GetCurrentUser().then(function (userInfo) {
        if (!!userInfo) {
          _this4.userLoggedIn = true;
        }

        var householdService = new HouseholdApiService();
        householdService.GetHouseholdMembers().then(function (members) {
          if (!!members && members.length > 0) {
            var allMembers = members.map(function (member) {
              return {
                id: member.contactId,
                value: member.displayName
              };
            });
            DropdownBuilder.LoadDropdown(_this4._$applyAs, allMembers, i18n.blankFormLabel);
            _this4._$applyAs.value = userInfo.contactId;
            _this4._$contactId.value = userInfo.contactId;
            _this4.userInfo = userInfo.user; // Toggle Address Blank Form

            if (!!_this4.userLoggedIn && !!_this4.userInfo.extentedProperties && !!_this4.userInfo.extentedProperties.ext_Address_Line_1) {
              _this4.HideAddressBlankForm();
            } else {
              _this4.ShowAddressBlankForm();
            } // Toggle Contact Blank Form


            _this4.HideContactBlankForm();
          }
        });
      }, function () {
        _this4._$applyAsWrapper.style.display = "none";

        _this4.ShowContactBlankForm();

        _this4._$contactId.value = "0";
      });
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners(i18n) {
      var _this5 = this;

      var self = this;
      var pledgeForm = new FormManager(this._$pledgeForm);
      this.CountrySelectOptions("USA");
      this.AttachGoogleMapsApi();

      this._$pledgeForm.addEventListener("submit", function (e) {
        ErrorBuilder.ClearAllAlerts(_this5._$alertContainer);
        e.preventDefault();

        if (pledgeForm.IsValid()) {
          var formData = new FormData(_this5._$pledgeForm);

          if (!formData.get("ContactId")) {
            formData.set("ContactId", 0);
          }

          _this5.AddNotesToFormData(formData);

          if (_this5._$createPledge != null) {
            _this5._$createPledge.disabled = true;
            _this5._$createPledge.value = i18n.applyingButtonText;
          }

          _this5._$createPledge;

          _this5._missionTripService.SavePledge(formData).then( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(response) {
              return regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) {
                  switch (_context2.prev = _context2.next) {
                    case 0:
                      pledgeForm.Reset(); // Re-draw custom form

                      _context2.next = 3;
                      return _this5.DrawCustomForm();

                    case 3:
                      ErrorBuilder.RenderAlert(_this5._$alertContainer, 'success', i18n.pledgeFormSuccessMessage);

                      _this5.ShowContactBlankForm();

                      _this5.ShowAddressBlankForm();

                      if (_this5._$createPledge != null) {
                        _this5._$createPledge.disabled = false;
                        _this5._$createPledge.value = i18n.applyButtonLabel;
                      }

                      window.scrollTo(0, 0);

                    case 8:
                    case "end":
                      return _context2.stop();
                  }
                }
              }, _callee2);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }())["catch"](function (error) {
            _this5._$alertContainer.innerHTML = '';
            ErrorBuilder.RenderHandler(_this5._$alertContainer, 'danger', error.details);
            console.error(error);
          });
        } else {
          ErrorBuilder.RenderAlert(_this5._$alertContainer, 'warning', i18n.pledgeFormWarningMessage);
        }
      });

      this._$applyAs.addEventListener("change", function () {
        ErrorBuilder.ClearAllAlerts(_this5._$alertContainer);
        var applyAsValue = _this5._$applyAs.value; // toggle contact form show contact fields if blank form

        if (!!applyAsValue) {
          // Toggle Address Blank Form
          if (!!_this5.userInfo && !!_this5.userInfo.extentedProperties && !!_this5.userInfo.extentedProperties.ext_Address_Line_1) {
            _this5.HideAddressBlankForm();
          } else {
            _this5.ShowAddressBlankForm();
          }

          _this5.HideContactBlankForm();

          _this5._$contactId.value = applyAsValue; // verify if user has pledged and provide warning

          _this5._missionTripService.HasPledged(_this5.pledgeCampaignID, applyAsValue).then(function (response) {
            if (response) {
              ErrorBuilder.RenderAlert(_this5._$alertContainer, 'warning', i18n.userHasAlreadyPledgedMessage);
            } else {
              _this5._$alertContainer.innerHTML = '';
            }
          })["catch"](function (error) {
            console.error(error);
            _this5._$alertContainer.innerHTML = '';
            ErrorBuilder.RenderAlert(_this5._$alertContainer, 'danger', 'pledgeCampaignService.HasPledged() inquiry has failed');
          });
        } else {
          _this5._$contactId.value = "0";
          _this5._$alertContainer.innerHTML = '';

          _this5.ShowContactBlankForm();

          _this5.ShowAddressBlankForm();
        }
      });
    }
  }, {
    key: "DrawCustomForm",
    value: function () {
      var _DrawCustomForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return CustomFormBuilder.RenderCustomForm(this._customFormGuid, this._$formFields, this._$pledgeForm, false, !!this.userInfo);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function DrawCustomForm() {
        return _DrawCustomForm.apply(this, arguments);
      }

      return DrawCustomForm;
    }()
  }, {
    key: "AddNotesToFormData",
    value: function AddNotesToFormData(formData) {
      var firstName = formData.get('FirstName');
      var lastName = formData.get('LastName');
      var email = formData.get('EmailAddress');
      var mobilePhoneNumber = formData.get('MobilePhoneNumber');
      var addressLine1 = formData.get('AddressLine1');
      var addressLine2 = formData.get('AddressLine2');
      var city = formData.get('City');
      var state = formData.get('StateRegion');
      var zip = formData.get('PostalCode');
      var country = formData.get('Country');
      var notes = "First Name: ".concat(firstName, "\nLastName: ").concat(lastName, "\nEmail: ").concat(email, "\nPhone: ").concat(mobilePhoneNumber, "\nAddress1: ").concat(addressLine1, " \nAddress2: ").concat(addressLine2, " \nCity, State, Zip: ").concat(city, ", ").concat(state, " ").concat(zip, "\nCountry: ").concat(country);
      formData.set('Notes', notes);
    }
  }, {
    key: "AttachGoogleMapsApi",
    value: function AttachGoogleMapsApi() {
      var _this6 = this;

      var applyAddress = function applyAddress(address) {
        if (!!address) {
          _this6._$addressLine1.value = address.addressLine1 || "";
          _this6._$addressLine2.value = "";
          _this6._$city.value = address.city || "";
          _this6._$stateRegion.value = address.state || "";
          _this6._$postalCode.value = address.postalCode || "";

          for (var idx in _this6._$country.options) {
            var option = _this6._$country.options[idx];

            if (option.innerHTML == address.country) {
              countrythis._$countryElement.value = option.value;
              break;
            }
          }
        }
      };

      var addressLine1Element = this._root.querySelector('#AddressLine1');

      this._addressAutoComplete.attach(addressLine1Element, function (address) {
        applyAddress(address);
      });
    }
  }, {
    key: "CountrySelectOptions",
    value: function CountrySelectOptions(countryCode) {
      var _this7 = this;

      this._lookupService.GetCountries().then(function (data) {
        _this7._localCountryCode = _this7._getLocalCountryCode(data);
        DropdownBuilder.BuildCountryDropdown(_this7._$country, data, "Country");
        _this7._$country.value = _this7.GetCountryCodeOrDefaultLocal(countryCode, data);
      })["catch"](function (error) {
        console.error(error);
        ErrorBuilder.RenderAlert(_this7._$emptyContainer, 'danger', error.StatusCode + (error.Details || error.Message));
      });
    }
  }, {
    key: "GetCountryCodeOrDefaultLocal",
    value: function GetCountryCodeOrDefaultLocal(countryCode, countyList) {
      var matches = countyList.filter(function (country) {
        return country.abbreviation == countryCode;
      });

      if (!!matches && matches.length > 0) {
        return countryCode;
      }

      return this._localCountryCode;
    }
  }, {
    key: "ShowContactBlankForm",
    value: function ShowContactBlankForm() {
      this._$contactFormWrapper.style.display = "";

      this._$firstName.setAttribute("required", true);

      this._$lastName.setAttribute("required", true);

      this._$email.setAttribute("required", true);

      this._$contactId.value = "0";
    }
  }, {
    key: "HideContactBlankForm",
    value: function HideContactBlankForm() {
      this._$contactFormWrapper.style.display = "none";

      this._$firstName.removeAttribute("required");

      this._$lastName.removeAttribute("required");

      this._$email.removeAttribute("required");
    }
  }, {
    key: "HideAddressBlankForm",
    value: function HideAddressBlankForm() {
      this._$addressFormWrapper.style.display = "none";
      var _this$userInfo$extent = this.userInfo.extentedProperties,
          ext_Address_Line_1 = _this$userInfo$extent.ext_Address_Line_1,
          ext_Address_Line_2 = _this$userInfo$extent.ext_Address_Line_2,
          ext_City = _this$userInfo$extent.ext_City,
          ext_Postal_Code = _this$userInfo$extent.ext_Postal_Code;
      this._$addressLine1.value = ext_Address_Line_1;
      this._$addressLine2.value = ext_Address_Line_2;
      this._$city.value = ext_City;
      this._$stateRegion.value = this.userInfo.extentedProperties['ext_State/Region'];
      this._$postalCode.value = ext_Postal_Code;
    }
  }, {
    key: "ShowAddressBlankForm",
    value: function ShowAddressBlankForm() {
      this._$addressFormWrapper.style.display = "";
      this._$addressLine1.value = "";
      this._$addressLine2.value = "";
      this._$city.value = "";
      this._$stateRegion.value = "";
      this._$postalCode.value = "";
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Mission Trip Application",
        tag: "mpp-mission-trip",
        configurationItems: [{
          name: "Pledge Campaign ID",
          attribute: "pledgecampaignid",
          description: "Determines the Campaign ID of Pledge Campaigns which will be eligible to appear in My Mission Trips.",
          required: true,
          type: "foreignkey",
          fkTable: "Pledge_Campaigns",
          fkFilter: "",
          fkSingleName: "Pledge Campaign"
        }, {
          name: "Applicant Email Template",
          attribute: "applicantemailtemplate",
          description: "Confirmation email sent after an individual has successfully submitted an application. Valid Value: Message ID (Default: Empty or NULL).",
          required: false,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["pledgecampaignid", "missiontripcampaignid", "applicantemailtemplate"];
    }
  }]);

  return MppMissionTrip;
}(ComponentBase);
MppMissionTrip.registerComponent(MppMissionTrip.WidgetDetails.tag, MppMissionTrip);